module.exports = __webpack_public_path__ + "static/media/8.0abd6b82.webp";